// extracted by mini-css-extract-plugin
export default {"container":"HmpMhjDXqjopnFYhLwMD","content":"tjaVx3UJ24IkUCgc3hYM","title":"Bb2BYhRcpF8frY41UhVt","propertiesCount":"ri97lRi3XT5MpCSMNUJ2","image":"ZhoOwwMsp7DHLbJPo0Yx"};